import React from 'react';
import { LayoutHeader } from './Header';
import { LayoutSidebar } from './Sidebar';
import { HEADER_HEIGHT } from 'constants/styles';
import { withRouterProps } from 'components/HOC/WithRouterProps';
import { inject, observer } from 'mobx-react';
import { IStore } from 'store';
import { RouterStore } from 'store/router.store';
import { IRouter } from 'config/router/interface';
import { computed } from 'mobx';
import { IUserInfo } from 'interface/user.interface';

interface Props extends IWithRouterProps {
  routerStore?: RouterStore;
  menus: IRouter[];
  userInfo: IUserInfo | null;
}

@withRouterProps
@inject((store: IStore) => {
  const { routerStore } = store;
  return {
    routerStore
  };
})
@observer
export class BasicLayout extends React.Component<Props> {
  public state = {
    isOpen: false
  };

  @computed
  get selectedItemKey(): string | undefined {
    const { menus, routerStore } = this.props;
    const router = routerStore!.currentRouter;

    if (menus && router) {
      const r = menus.find(i => router.pathname === i.path);
      return r ? r.key : undefined;
    }

    return undefined;
  }

  public getSnapshotBeforeUpdate() {
    const { location, routerStore } = this.props;
    routerStore!.updateCurrentRouter(location);
    return true;
  }

  public componentDidUpdate() {}

  public componentDidMount() {
    const { location, routerStore } = this.props;
    routerStore!.updateCurrentRouter(location);
  }

  public setOpen = (params: boolean) => () => {
    this.setState({
      isOpen: params
    });
  };

  public render() {
    const { children, menus, userInfo } = this.props;
    const { isOpen } = this.state;

    return (
      <>
        <LayoutHeader hanleMenu={this.setOpen(!isOpen)} userInfo={userInfo} />

        <React.Fragment>
          {userInfo ? (
            <LayoutSidebar
              isOpen={isOpen}
              menus={menus}
              closeMenu={this.setOpen(false)}
              selectedItemKey={this.selectedItemKey}
            />
          ) : null}
          <main
            style={{
              height: `calc(100vh - ${HEADER_HEIGHT})`,
              marginTop: HEADER_HEIGHT,
              width: '100%'
            }}
          >
            {children}
          </main>
        </React.Fragment>
      </>
    );
  }
}
